/* @flow strict */

/* eslint-disable camelcase */
import * as React from 'react';
import { GET } from '/client/src/api';
import { CheckIcon } from '../checkIcon';
import { TicketFeeType } from '/client/src/constants/';
import SimpleInput from '../../forms/simpleInput';
import './codeForm.scss';
import '../checkout.scss';


type DiscountCodeFormType = {
  eventDetail: {},
  visibleTickets: [],
  buyCart: [],
  handleUpdateBuyCart: () => void,
  handleUpdateVT: () => void
};

const DiscountCodeForm = (props: DiscountCodeFormType): React.Element<'div'> => {
  const [code, setCode] = React.useState('');
  // 1 - loading, 2 - success, 3 - error
  const [promoCodeState, setCodeRes] = React.useState(0);
  const [promoCodeErrorMsg, setPromoCodeErrorMsg] = React.useState('Your promo code is invalid. Try again later!');
  const { eventDetail, visibleTickets, buyCart, handleUpdateBuyCart, handleUpdateVT } = props;

  const removeWarning = () => {
    setTimeout(() => {
      setCodeRes(0);
      setCode('');
    }, 2000);
  };

  const sendRequest = async () => {
    try {
      const _code = code.replace(/(^\s*)|(\s*$)/g, '');

      if (!/^[A-z0-9-+]{1,128}$/.test(_code)) {
        return;
      }

      // NProgressCustom(true);
      setCodeRes(1);

      // eslint-disable-next-line
      const { result } = await GET(`/api/v1/1/events/${eventDetail.id}/couponcodes/${_code}?paymentMethod=StripeTokenDirect`);
      const codes = result;

      if (!!_.size(codes)) {
        // Clear all discount information first
        // Clean up all coupon code IDs

        for (const c of codes) {
          const { applied_to_tickets } = c;

          const t = [];
          const t2 = [];

          // Add new coupon ID
          for (let i = 0; i < _.size(applied_to_tickets); i++) {
            const fn = (_t: {}, applied_to_ticket: {}): {} => {
              const __ticket: {} = _.clone(_t);

              if (_.toString(__ticket.id) === _.toString(applied_to_ticket.id)) {
                const discount = __ticket.discount_amount;

                __ticket.discount_fee = applied_to_ticket.fee;

                if (discount < applied_to_ticket.discount_amount) {
                  __ticket.discount_amount = applied_to_ticket.discount_amount;

                  // If fee_type is ExcludeFee(2), you need to recalculate fee
                  if (__ticket.fee_type === TicketFeeType.ExcludeFee) {
                    __ticket.discount_fee =
                      _.get(applied_to_ticket, 'payment_method_additional_fee', 0) +
                      _.get(applied_to_ticket, 'payment_method_additional_fix_fee', 0) +
                      _.get(applied_to_ticket, 'sparxo_fee', 0) +
                      _.get(applied_to_ticket, 'merchant_fee', 0);
                  }

                  if (_t.tax_use_percentage) {
                    __ticket.price_with_discount = __ticket.price - (__ticket.price * __ticket.tax_percentage / 100);
                  } else {
                    __ticket.price_with_discount = __ticket.price - __ticket.tax;
                  }
                }
              }

              return __ticket;
            };

            _.map(visibleTickets, (_t: {}): {} => {
              if (_.toString(_t.id) === _.toString(applied_to_tickets[i].id)) {
                const ticket_ =  fn(_t, applied_to_tickets[i]);

                t.push(ticket_);
              }

              return _t;
            });


            _.map(buyCart, (_t: {}): {} => {
              if (_.toString(_t.id) === _.toString(applied_to_tickets[i].id)) {
                const ticket_ =  fn(_t, applied_to_tickets[i]);

                t2.push(ticket_);
              }

              return _t;
            });
          }

          handleUpdateVT(t);
          handleUpdateBuyCart(t2);
        }
      }

      setCodeRes(codes ? 2 : 3);

      if (!_.size(codes)) {
        removeWarning();
      }

      // NProgressCustom(false);
    } catch (error) {
      console.error(error);
      // NProgressCustom(false);

      removeWarning();

      if (error && error.code === 800010) {
        setPromoCodeErrorMsg('Oops, looks like the coupon code you\'ve entered has expired.');
      } else {
        setPromoCodeErrorMsg('Invalid code.');
      }

      setCodeRes(3);
    }
  };

  return (
    <div className={`
        sparxo-checkout-codeForm_container
        ${promoCodeState === 2 ? 'sparxo-checkout-codeForm_containerSuccess' : ''}
        ${promoCodeState === 3 ? 'sparxo-checkout-codeForm_containerError' : ''}
        `}
    >
      {promoCodeState === 0 ?
        <form className="sparxo-checkout-codeForm_form">
          <div className="sparxo-checkout-codeForm_title">Have a discount code?</div>
          <div className="sparxo-checkout-codeForm_inputContainer">
          <SimpleInput
            type='text'
            id={'splashPage-discountCode'}
            name='discountCode'
            value={code}
            classes={{ input: 'sparxo-checkout-codeForm_input' }}
            style={{ width: '100%', marginRight: '14px' }}
            placeholder='Enter discount code here'
            onChange={(e: any): void => setCode(e.target.value)}
          />
          <button
            type="submit"
            className="sparxo-checkout_action_btn"
            onClick={(e: any) => {
              e.preventDefault();
              sendRequest();
            }}
          >Apply code
          </button>
          </div>
        </form>
        :
        <span className="sparxo-checkout-codeForm_codeStatus splashPage-codeStatus">
          {promoCodeState === 1 &&
            <div className="sparxo-checkout-codeForm_loaderBlock">
              <span className='csspinner' />
            </div>
          }
          {promoCodeState === 2 && <><CheckIcon/> Your code has been applied!</>}
          {promoCodeState === 3 && <>{promoCodeErrorMsg}</>}
        </span>
      }
    </div>
  );
};

export default DiscountCodeForm;
